import { isWebView } from 'src/utils/platform';
import { ReactNativeImageCacheAdapter } from './adapters/react-native';
import { WebImageCacheAdapter } from './adapters/web';
class ImageCacheFactory {
    static instance;
    static getInstance() {
        if (!ImageCacheFactory.instance) {
            ImageCacheFactory.instance = isWebView
                ? new ReactNativeImageCacheAdapter()
                : new WebImageCacheAdapter();
        }
        return ImageCacheFactory.instance;
    }
}
export default ImageCacheFactory;
